import React, { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { useCamp } from "@/context/SettingsContext";
import { useLang } from "@/i18n";

// operationele schermen waar met één druk 1 dummy-record bijkomt (lang indrukken = 10)
const KINDS = {
  "/gasten": "guest",
  "/reservaties": "reservation",
  "/aankomend": "arrival",
  "/verblijven": "stay",
  "/vertrekkend": "departure",
  "/facturen": "invoice",
  "/verkopen": "sale",
  "/verhuur": "rental",
};
const BULK = 10;
const HOLD_MS = 600;

export default function DummyButton({ onAdded }) {
  const { camp } = useCamp();
  const { t } = useLang();
  const { pathname } = useLocation();
  const [busy, setBusy] = useState(false);
  const [holding, setHolding] = useState(false);
  const timer = useRef(null);
  const fired = useRef(false);
  const kind = KINDS[pathname];

  if (!camp?.demo_mode || !kind) return null;

  const add = async (count) => {
    setBusy(true);
    try {
      await api.post(`/dummy/add/${kind}`, null, { params: { count } });
      toast.success(count > 1 ? `${t("dummy_added_bulk")} (${count})` : t("dummy_added"));
      onAdded?.();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setBusy(false); setHolding(false); }
  };

  const down = () => {
    if (busy) return;
    fired.current = false;
    setHolding(true);
    timer.current = setTimeout(() => { fired.current = true; add(BULK); }, HOLD_MS);
  };
  const up = () => {
    clearTimeout(timer.current);
    setHolding(false);
    if (!fired.current && !busy) add(1);
  };
  const cancel = () => { clearTimeout(timer.current); setHolding(false); fired.current = true; };

  return (
    <button type="button" disabled={busy} data-testid="dummy-add-button"
      onPointerDown={down} onPointerUp={up} onPointerLeave={cancel} onContextMenu={(e) => e.preventDefault()}
      title={t("dummy_add_hint")}
      className="cb-3d-red fixed bottom-6 right-6 z-40 flex items-center gap-2 rounded-full px-5 py-3 font-display text-sm font-black uppercase tracking-wider text-white">
      <Plus className={`h-5 w-5 ${holding ? "animate-spin" : ""}`} strokeWidth={3} />
      {holding ? `+${BULK}` : t("dummy_add")}
    </button>
  );
}
